import { Link, useNavigate } from 'react-router';
import Spinner from '../../../components/spinner/Spinner';
import RoundedImage from '../../../components/RoundedImage';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import TrackEventLink from '../../../components/track-event-link/TrackEventLink';
import styles from './public-subproject-list-item.module.less';
import { ActionButton } from '@sb1/ffe-buttons-react';
import { isActive } from '../../project-model';
import { useProject } from '../../project-hooks/useProject';
import { formatMoneyKr } from '../../../utils';

const PublicSubprojectListItem = ({ subproject, projectId, invite, joinUrl, showCollected }) => {
    const navigate = useNavigate();
    const project = useProject();
    const subprojectUrl = `/project/${projectId}?subproject=${subproject.id}`;

    const onSupportClick = () => {
        trackEvent('project', 'subproject-support', { projectId, subprojectId: subproject.id });
        navigate(subprojectUrl);
    };

    if (subproject?.anonymous) {
        return null;
    }

    if ((!subproject || subproject.isFetching) && !invite) {
        return <Spinner size="20px" />;
    }

    if (subproject?.isError) {
        return null;
    }
    if (invite) {
        return (
            <div className={[styles.subprojectListItem, styles.inviteParticipants, styles.roundCorners].join(' ')}>
                <RoundedImage size={''} className={styles.addSubprojectBubble} src={'plus-rounded.svg'} />
                <Link className={styles.subprojectOwner} to={`/project/${projectId}/control/subprojects`}>
                    Inviter deltakere
                </Link>
            </div>
        );
    }
    if (joinUrl) {
        return (
            <div
                className={[styles.subprojectListItem, styles.inviteParticipants, styles.roundCorners].join(' ')}
                onClick={() => navigate(joinUrl)}
            >
                <RoundedImage size={''} className={styles.addSubprojectBubble} src={'plus-rounded.svg'} />
                <Link className={styles.subprojectOwner} to={joinUrl}>
                    Bli med!
                </Link>
            </div>
        );
    }
    return (
        <div className={[styles.subprojectListItem, styles.roundCorners].join(' ')}>
            <RoundedImage
                size={''}
                className={styles.subprojectCardImgBubble}
                src={subproject.img_url || subproject.fallback_img_url}
            />
            <TrackEventLink
                to={subprojectUrl}
                className={styles.subprojectOwner}
                category="project"
                action="subproject-link"
                properties={{ projectId, subprojectId: subproject.id }}
            >
                {subproject.name}
            </TrackEventLink>
            {showCollected && <div>{formatMoneyKr(subproject.collected)}</div>}
            {showCollected && <div className={styles.collectedText}>innsamlet</div>}
            {isActive(project) && (
                <div className={styles.buyButton}>
                    <ActionButton onClick={onSupportClick}>Støtt</ActionButton>
                </div>
            )}
        </div>
    );
};

export default PublicSubprojectListItem;
